export default "/images/6280851449ac66f599a714fd0f8f0903.avif";